import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard  {
  //
  public url : any;
  constructor(public router: Router, private jwtHelper: JwtHelperService) { }
  ngOnInit(){
    this.url = this.router.url;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

      console.log('admin.guard.ts route'+ state.url)

     if(state.url === '/authentication/forget-password'
     || state.url === '/sign-up'
     || state.url === '/kb'){
        console.log('Nao Logados')
        return true;
      }

   // Pega o token do localStorage
   const token = localStorage.getItem('token');

   // Se não há token ou está expirado, redireciona para login
   if (!token || this.jwtHelper.isTokenExpired(token)) {
     console.log('Usuário não autenticado. Redirecionando para login.');
     // Salva a URL atual antes de redirecionar
     localStorage.setItem('redirectUrl', state.url);
     this.router.navigate(['/auth/login']);
     return false;
   }

    // Decodifica o token JWT para obter as roles do usuário
    const decodedToken = this.jwtHelper.decodeToken(token);
    //console.log(decodedToken);
    const userRoles = decodedToken?.RealdeskRole || [];

    localStorage.setItem('rolesUsuario', userRoles);

    //alert(userRoles);
    // Pega as roles exigidas pela rota
    const requiredRoles = route.data['roles'] as Array<string>;

    // Se a rota exige roles específicas, verifica se o usuário tem permissão
    if (requiredRoles && !requiredRoles.some(role => userRoles.includes(role))) {
      console.log('Acesso negado. Redirecionando para página não autorizada.');
      this.router.navigate(['/unauthorized']);
      return false;
    }

    console.log('Acesso permitido.');

    return true;
  }

    // 🔥 Método para obter as roles do usuário logado
    getUserRoles(): string[] {
      const roles = localStorage.getItem('rolesUsuario');
      return roles ? roles.split(',') : [];
    }
  
    // 🔥 Método para verificar se o usuário tem uma role específica
    hasRole(role: string): boolean {
      return this.getUserRoles().includes(role);
    }


}
